interface Props {
  label: string
  data: string | undefined
  enlighten?: boolean
}

const ProcedureDataItem = ({ label, data, enlighten }: Props) => {
  return (
    <div className="detail-item">
      <span style={{ fontWeight: '700' }}>{label}: </span>
      {label === 'Estado' || (label.includes('línea') && enlighten) ? (
        <span
          style={{ fontWeight: '600' }}
          className={`${
            label.includes('línea') && enlighten && 'line-number-color'
          } ${label === 'Estado' && data?.toLowerCase()}`}
        >
          {data}
        </span>
      ) : (
        <span style={{ fontWeight: '400' }}>{data}</span>
      )}
    </div>
  )
}

export default ProcedureDataItem
